<div fxLayout="row" fxLayoutAlign="space-between start" class="header m-b-32">
  <div class="popup-title" fxFlex>PRIVACY POLICY OF CURRICULUM LTD</div>
  <curr-icon-button icon="close" (click)="dialogRef.close()"></curr-icon-button>
</div>

<div class="full-width popup-content hidden-y-scroll">
  <curr-privacy-policy-content></curr-privacy-policy-content>
</div>
